import { fetchData } from '../../api';
import {getProviderClass, getProviderDisplayName} from '../utils/providers';

export const steps = [
  {
    id: 1,
    text: 'Select a Streaming Service',
    getOptions: async () => {
      const { data } = await fetchData('/api/tag/?category=provider&limit=10');
      return data.map(tag => ({ value: tag.name, label: getProviderDisplayName(tag.name), className: `${getProviderClass(tag.name)}` }));
    },
  },
  {
    id: 2,
    text: 'What mood or genre are you in the mood for?',
    getOptions: async (answers) => {
      const providerAnswer = answers[0];
      if (!providerAnswer) return [];
      const providerId = providerAnswer.value;
      const { data } = await fetchData(`/api/tag/?category=genre&limit=12&containing=${providerId}`);
      return data.map(tag => ({ value: tag.name, label: tag.name, className: "" }));
    },
  },
];
